import React, { useState } from 'react';
import styled from 'styled-components';

const ProfileContainer = styled.div`
  background-color: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 2px rgba(0,0,0,0.08);
  padding: 2rem;
  max-width: 400px;
  margin: 2rem auto;
`;

const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 1.5rem;
`;

const Label = styled.label`
  font-weight: 500;
  color: #374151;
  display: block;
  margin-bottom: 0.5rem;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  font-size: 0.95rem;
  margin-bottom: 1rem;
`;

const Checkbox = styled.input`
  margin-right: 0.5rem;
`;

const Button = styled.button`
  background-color: #2563eb;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  margin-top: 1rem;
`;

const TeacherProfile: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [name, setName] = useState('Madam Elliot');
  const [notify, setNotify] = useState(true);

  return (
    <ProfileContainer>
      <Title>Teacher Profile & Settings</Title>
      <Label htmlFor="name">Name</Label>
      <Input id="name" value={name} onChange={e => setName(e.target.value)} />
      <Label>
        <Checkbox type="checkbox" checked={notify} onChange={e => setNotify(e.target.checked)} />
        Receive notifications
      </Label>
      <Button onClick={onClose}>Close</Button>
    </ProfileContainer>
  );
};

export default TeacherProfile; 